module.exports = __webpack_public_path__ + "odstraneni-tetovaze_8_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/odstraneni-tetovaze_8_after.jpg
// module id = 965
// module chunks = 0